<template>
  <div>
    <v-container grid-list-xl class="ma-0 pa-5" v-if="current_instansi">
      <m-breadcrum class="my-6" :items="bread"></m-breadcrum>
      <v-row class="mt-2">
        <v-col cols="12" sm="12" md="4" lg="4" v-if="sectionTelegram">
          <m-info
            border
            color="#7400D9"
            :title="`Bantuan Seri ` + current_instansi.nama"
            icon="mdi-help-circle"
            :mdIcon="2"
            :mdInfo="10"
            :lgIcon="2"
            :lgInfo="10"
            :xlIcon="2"
            :xlInfo="10"
            textButton="Bantuan"
            emitButton="toInfoTelegram"
            @toInfoTelegram="infoJoinTelegram"
          ></m-info>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="4" v-if="sectionSertifikat">
          <m-info
            border
            color="#7400D9"
            title="Sertifikat Kegiatan"
            icon="mdi-certificate-outline"
            :mdIcon="2"
            :mdInfo="10"
            :lgIcon="2"
            :lgInfo="10"
            :xlIcon="2"
            :xlInfo="10"
            emitButton="tosertifikat"
            @tosertifikat="toSertifikat"
          ></m-info>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12" v-if="informasis.length > 0">
          <v-alert class="mb-0 pb-4 mt-4" color="info" dismissible text v-for="info in informasis" :key="info.id">
            <template>
              <p class="font-weight-bold my-0 py-0 black--text">{{ info.judul }}</p>
              <div class="my-0 py-0 black--text" v-html="info.informasi"></div>
            </template>
          </v-alert>
        </v-col>
      </v-row>
      <v-row no-gutters class="mb-6 mt-8" v-if="current_instansi.id == 56">
        <v-col cols="12">
          <v-alert
            light
            class="py-4"
            prominent
            dense
            text
            :type="isKasek && sekolahSasaranKSactive.is_terdaftar_diklat ? 'success' : diklatku.length > 0 && diklatku[0].kelasku.length > 0 ? 'success' : 'info'"
          >
            <template>
              <v-row no-gutters justify="center" align="center" fill-height>
                <v-col cols="12" md="10">
                  <p class="title black--text my-0 py-0 pb-0">
                    {{
                      isKasek && sekolahSasaranKSactive.is_terdaftar_diklat
                        ? "Akun telah terdaftar "
                        : isKasek && !sekolahSasaranKSactive.is_sasaran
                          ? "Sekolah Anda tidak termasuk Sasaran Diklat."
                          : diklatku.length > 0 && diklatku[0].kelasku.length > 0
                            ? "Akun Anda terdaftar di Seri " + this.current_instansi.nama
                            : "Mekanisme Pendaftaran"
                    }}
                  </p>
                  <span class="black--text text--darken-2" v-if="(isKasek && sekolahSasaranKSactive.is_terdaftar_diklat) || (diklatku.length > 0 && diklatku[0].kelasku.length > 0)">{{
                      isKasek && sekolahSasaranKSactive.is_terdaftar_diklat
                        ? "Anda terdaftar sebagai peserta Seri " + this.current_instansi.nama + "dari sekolah " + this.sekolahSasaranKSactive.nama + " "
                        : ""
                    }}</span>
                  <span class="black--text text--darken-2" v-else-if="isKasek && !sekolahSasaranKSactive.is_sasaran"> </span>
                  <span class="black--text text--darken-2" v-else
                  >Pendaftaran individu tidak tersedia untuk seri ini, pendaftaran dilakukan oleh Kepala Sekolah Jenjang PAUD/SD yang terdaftar sebagai Sasaran Diklat.
                    <span v-if="isKasek && sekolahSasaranKSactive.is_sasaran && (sekolahSasaranKSactive.jenjang_id == 1 || sekolahSasaranKSactive.jenjang_id == 2)"
                    >Silakan gunakan tombol <strong>DAFTAR</strong> untuk mengakses menu pendaftaran dan melanjutkan proses.</span
                    ></span
                  >
                </v-col>
                <v-col col="12" md="2" class="text-center">
                  <m-button
                    v-if="isKasek && sekolahSasaranKSactive.is_sasaran && (sekolahSasaranKSactive.jenjang_id == 1 || sekolahSasaranKSactive.jenjang_id == 2)"
                    class="my-2"
                    depressed
                    :color="
                      isKasek && sekolahSasaranKSactive.is_terdaftar_diklat ? 'green darken-1' : diklatku.length > 0 && diklatku[0].kelasku.length > 0 ? 'green darken-1' : 'blue darken-1'
                    "
                    :textButton="isKasek && sekolahSasaranKSactive.is_terdaftar_diklat ? 'Lihat' : diklatku.length > 0 && diklatku[0].kelasku.length > 0 ? 'Lihat' : 'Daftar'"
                    action="daftarKS"
                    @daftarKS="daftarKS(sekolahSasaranKSactive.is_terdaftar_diklat)"
                  ></m-button>
                </v-col>
              </v-row>
            </template>
          </v-alert>
        </v-col>
        <v-col cols="12" v-if="isKasek" @click="switchSekolah">
          Anda menjabat sebagai <strong class="primary--text">Kepala Sekolah {{sekolahSasaranKSactive.nama}} <v-icon color="primary" >mdi-chevron-down</v-icon></strong>
        </v-col>
      </v-row>
      <v-row wrap v-for="diklat in diklatku" :key="diklat.index">
        <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="text-h5 font-weight-bold" v-if="filteredKelasAktif(diklat.kelasku).length > 0"
        >Kegiatan yang sedang berlangsung
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="my-0 py-1" v-for="(kelas, index) in filteredKelasAktif(diklat.kelasku)" :key="kelas.index">
          <CourseCard
            :title="kelas.nama"
            :angkatan="kelas.angkatan"
            isangkatan
            :isJadwalUlang="cekJadwalUlang(diklat, kelas.jenis, index == diklat.kelasku.length - 1 ? 1 : 0)"
            type="enroll"
            :item="kelas"
            icon="mdi-account"
            @ubahJadwal="ubahJadwal"
            @info="toInfo"
            @survei="survei"
            @detailActivity="detailActivity"
          />
        </v-col>
      </v-row>
      <div class="py-6"></div>
      <v-row wrap v-if="showKelasAktif">
        <v-col cols="12" sm="12" md="12" lg="12" xl="12" v-if="jenisKelases.length > 0">
          <span class="text-h5 font-weight-bold">Kegiatan yang bisa Anda ikuti</span>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" xl="4" v-for="jenis in jenisKelases" :key="jenis.key">
          <CourseCard
            :title="jenis.keterangan"
            :syarat="jenis.syaratKelases"
            :isdisable="jenis.isdisable"
            :isangkatan="false"
            icon="mdi-account"
            :item="jenis"
            type="pilihJenis"
            :isModeKelas="false"
            @survei="survei"
            @pilih="
              jenis.tag == 'lms'
                ? pilihJadwal('pilih', jenis, jenis.is_show_course, jenis.id)
                : jenis.tag == 'video'
                ? unggahVideo(jenis, jenis.is_show_course, jenis.id)
                : jenis.tag == 'token'
                ? formToken(jenis, jenis.is_show_course, jenis.id)
                : jenis.tag == 'survei'
                ? formSurvei(jenis, jenis.is_show_course, jenis.id)
                : pilihJadwal('pilih', jenis, jenis.is_show_course, jenis.id)
            "
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" xl="4" v-if="cardSyaratGagal && jenisKelases.length == 0 && diklatku.length == 0">
          <CourseCard
            :title="current_instansi.nama"
            :isSyarat="false"
            :isdisable="true"
            :isangkatan="false"
            icon="mdi-account"
            :item="infoSeri"
            type="pilihJenis"
            :isModeKelas="false"

          />
        </v-col>
      </v-row>
      <div class="py-2"></div>
      <v-row v-if="jenisKelases.length == 0 && diklatku.length == 0 && !cardSyaratGagal">
        <v-col cols="12" sm="12" md="12" lg="12" xl="12"><span class="text-h5 font-weight-bold">Kegiatan yang bisa Anda ikuti</span></v-col>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mt-0 pt-0">
          <span class="title black--text"><m-alert show info="Tidak tersedia jadwal kegiatan yang bisa Anda ikuti"></m-alert></span>
        </v-col>
      </v-row>
      <div class="mt-8 mb-2" v-if="jenisKelases.length > 0"></div>
      <v-row wrap v-for="diklat in diklatku" :key="diklat.index">
        <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-6 pb-4" v-if="filteredKelasComplete(diklat.kelasku).length > 0">
          <span class="text-h5 font-weight-bold">Kegiatan yang telah Anda ikuti</span>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="my-0" v-for="kelas in filteredKelasComplete(diklat.kelasku)" :key="kelas.index">
          <CourseComplete
            :key="Math.random()"
            :tag="kelas.jenis.tag"
            @info="toInfo"
            @unggah="toSyaratPengimbasan"
            @detailActivity="detailActivity"
            :video="pengimbasan ? pengimbasan[0] : {}"
            @pilih="formSurvei(kelas.jenis, kelas.jenis.is_show_course, kelas.jenis.id)"
            :item="kelas"
          />
        </v-col>
      </v-row>

      <Form ref="dlgJenjang"/>
      <InfoJoinTelegram ref="dlgInfoTelegram"/>
      <InfoSekolahSasaran ref="dlgSekolahSasaran"/>
      <PilihSekolahSasaran ref="dlgPilihSekolahSasaran"/>
      <infoUnggahDokumen ref="dlgInfoKomunitas"/>
      <PilihKelasDialog ref="dlgKelas"/>
      <SertifikatDialog ref="dlgSertifikat"/>
      <SyaratPengimbasan ref="dlgPengimbasan"/>
      <InfoKelas ref="dlgInfoKelas" :infoKelas="infoKelas"/>
      <InfoKelasLuring ref="dlgInfoKelasLuring"/>
      <!-- <Info ref="dlgInfo" /> -->
      <Token ref="dlgToken"/>
      <Peserta ref="dlgPeserta"/>
      <FormEksternalDialog ref="dlgKelasEksternal"/>
      <FormTokenDialog ref="dlgKelasToken"/>
      <FormTokenSusulanDialog ref="dlgTokenSusulan"/>
      <FormUnggahVideo ref="dlgVideoPengimbasan"/>
      <FormPilihInstansi ref="dlgInstansi"/>
      <RegistrasiKSForm ref="registrasiDlg"/>
      <dialog-info ref="dlgInfo"/>
      <InfoDetailLMS ref="dlgDetailActivity"/>
    </v-container>
  </div>
</template>

<script>
import {SIMPKB, SIM, SSO} from "@/const";
import Form from "../../user/components/Form.vue";
// import Info from "../components/Info.vue";
import Token from "../components/Token.vue";
import Peserta from "../components/PesertaTuntas.vue";
import InfoDetailLMS from "../components/InfoDetailLMS.vue";
import InfoSekolahSasaran from "../components/InfoSekolahSasaran.vue";
import PilihSekolahSasaran from "../components/PilihSekolahSasaran.vue";
import InfoKelasLuring from "../../kelas/components/InfoKelasLuring.vue";
import FormTokenSusulanDialog from "../../kelas/components/FormTokenSusulanDialog.vue";

export default {
  components: {
    CourseCard: () => import("@/components/CourseCard"),
    CoursePengimbasan: () => import("@/components/CoursePengimbasan"),
    CourseComplete: () => import("@/components/CourseComplete"),
    PilihKelasDialog: () => import("../../kelas/components/PilihKelasDialog"),
    FormUnggahVideo: () => import("../../kelas/components/FormUnggahVideo"),
    FormEksternalDialog: () => import("../../kelas/components/FormEksternalDialog"),
    FormTokenDialog: () => import("../../kelas/components/FormTokenDialog"),
    SertifikatDialog: () => import("../../kelas/components/SertifikatDialog"),
    InfoJoinTelegram: () => import("../components/InfoJoinTelegram.vue"),
    infoUnggahDokumen: () => import("../components/InfoUnggahDokumen.vue"),
    InfoKelas: () => import("../../kelas/components/InfoKelas"),
    SyaratPengimbasan: () => import("../../kelas/components/SyaratPengimbasan"),
    FormPilihInstansi: () => import("../../kelas/components/FormPilihInstansiDialog"),
    RegistrasiKSForm: () => import("../components/RegistrasiKS.vue"),
    InfoKelasLuring,
    FormTokenSusulanDialog,
    InfoSekolahSasaran,
    Form,
    Token,
    Peserta,
    PilihSekolahSasaran,
    InfoDetailLMS,
  },

  data() {
    return {
      allJenisKelas: [],
      jenisKelases: [],
      kelasTersedias: [],
      diklats: [],
      diklatku: [],
      info: true,
      infoKelas: null,
      page: 1,
      inProgressClass: false,
      joinTelegram: false,
      lastMissedClass: null,
      syarats: [],
      panel: [1],
      cardSyaratGagal: false,
      informasis: [],
      infoSeri: {
        id: 1,
        keterangan: "Orientasi",
        is_kuota: 0,
        is_show_course: 0,
        is_pindah: 0,
        is_selfenrol: 0,
        cover: null,
        mode_id: 0,
        is_daring: 1,
        jml_kelas_available: 1
      },
      pengimbasan: [],
      is_lulus_bimtek: false,
      statusUnggah: false,
      validUrl: false,
      jenisAKM: [12, 13, 14, 15],
      isRegistered: false,
      sectionTelegram: false,
      sectionKomunitas: false,
      sectionSertifikat: false,
      instansiTerpilih: [],
      countSelectInstansi: false,
      config: [],
      syaratKS_PSP: false,
      syaratKS_SMKPK: false,
      isKasek: false,
      sekolahSasaranKS: null,
      sekolahSasaranKSactive: null
    };
  },
  activated() {
    this.infoSeri.cover = this.current_instansi.cover;
  },
  mounted() {



    this.loadConfig();
    // this.loadInstansiTerpilih(this.instansi_id);
    this.getCourse();
    // this.loadStatusPengimbasan();
    // this.cekStatusJenjang();

    if (!this.current_user.is_super_admin) {
      this.loadSekolah();
    }
  },
  computed: {
    bread() {
      // return [
      //   {
      //     icon: "mdi-home",
      //     title: "Pilihan Seri",
      //     to: { name: "instansi.pilih" }
      //   },
      //   {
      //     icon: "mdi-edit",
      //     title: this.current_instansi ? this.current_instansi.nama : "-"
      //   }
      // ];
      if (this.current_instansi.parent_id == 0) {
        return [
          {
            icon: "mdi-home",
            title: "Pilihan Seri",
            to: {name: "instansi.pilih"}
          },
          {
            icon: "mdi-edit",
            title: this.current_instansi ? this.current_instansi.nama : "-"
          }
        ];
      } else {
        return [
          {
            icon: "mdi-home",
            title: "Pilihan Seri",
            to: {name: "instansi.pilih"}
          },
          {
            icon: "mdi-edit",
            title: "PAUD",
            to: {name: "instansi.pilih.sub", params: {parent_id: this.current_instansi.parent_id}}
          },
          {
            icon: "mdi-edit",
            title: this.current_instansi ? this.current_instansi.nama : "-"
          }
        ];
      }
    },
    showKelasAktif() {
      if (this.diklatku.length > 0) {
        if (this.filteredKelasAktif(this.diklatku[0].kelasku).length > 0 && this.current_instansi.id == 7) {
          return false;
        } else {
          return true;
        }
      } else if (this.diklatku.length == 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {

    loadConfig() {
      this.loading = true;
      return this.$store
        .dispatch("instansi/config", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          var configsectionTelegram = res.filter(r => r.key == "sectionTelegram");
          this.sectionTelegram = configsectionTelegram && configsectionTelegram.length > 0 ? false : true;
          var configsectionKomunitas = res.filter(r => r.key == "sectionKomunitas");
          this.sectionKomunitas = configsectionKomunitas && configsectionKomunitas.length > 0 ? true : false;
          var configsectionSertifikat = res.filter(r => r.key == "sectionSertifikat");
          this.sectionSertifikat = configsectionSertifikat && configsectionSertifikat.length > 0 ? false : true;
          this.config = res;
        })
        .catch(e => e);
    },

    detailActivity(item) {
      this.$refs.dlgDetailActivity.open(item)
    },

    loadSekolah() {
      this.loading = true;
      return this.$store
        .dispatch("user/sekolah", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          //filter hanya sekolah sasaran
          let sekolahSasaran = res.filter(sklh => sklh.is_sasaran == true);
          if(sekolahSasaran.length>0){
            this.cekSekolahSasaran(sekolahSasaran)
            this.sekolahSasaranKS = sekolahSasaran;
            this.sekolahSasaranKSactive = sekolahSasaran[0];
            this.isKasek = sekolahSasaran[0].sekolah_id ? true : false;
          }

        })
        .catch(e => e);
    },

    switchSekolah(){
      this.$refs.dlgPilihSekolahSasaran.open(this.sekolahSasaranKS).then(res => {
        this.sekolahSasaranKSactive = {...res}
        this.getCourse();
      });


    },

    getTokenSSO() {
      const url = SSO + SIM + "/#/to-mobile-app";
      window.open(url, "_self");
    },

    survei() {
      const url = SSO + SIM + "/#/to-mobile-app";
      window.open(url, "_self");
    },

    loadInformasi() {
      return this.$store
        .dispatch("instansi/getInformasi", this.instansi_id)
        .then(res => {
          this.informasis = res.filter(r => r.jenis.id === 1);
          const infoDialog = res.filter(r => r.jenis.id === 2);
          this.$refs.dlgInfo.open(infoDialog.length > 0 ? infoDialog[0] : null);
        })
        .catch(e => e);
    },

    loadStatusPengimbasan() {
      return this.$store
        .dispatch("kelas/statusPengimbasan", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          this.pengimbasan = res[0];
          if (res.length > 0) {
            this.statusUnggah = true;
            // jika status nya 2 (approved), url dicatat sebagai valid url
            if (res[0].status == 2) {
              this.validUrl = true;
            } else {
              // jika tidak valid tampilkan notifikasi
              this.validUrl = false;
            }
          } else {
            this.statusUnggah = false;
          }
        })
        .catch(e => e);
    },

    daftarKS(status) {
      this.$refs.registrasiDlg.open(this.sekolahSasaranKSactive, status).then(() => {
        this.getCourse();
        if (!this.current_user.is_super_admin) {
          this.loadSekolah();
        }
      });
    },

    toInfo(val) {
      this.$refs.dlgInfoKelasLuring.open(val).then(() => {
        this.getCourse();
      });
    },

    getJenisKelas(diklatAktif) {
      this.jenisKelases = [];
      return this.$store
        .dispatch("kelas/getJenis", this.instansi_id)
        .then(res => {
          this.allJenisKelas = res;

          // filter jenis kelas non kelas public / enroll manual / dipilih
          var jenisKelasFiltered = res.filter(kelas => kelas.jml_kelas_available > 0);

          // kelas yang sudah dipilih
          if (diklatAktif) {
            // kelas dipilih, kelas belum selesai, maka jenis kelas yang sama hilang
            var kelasTerpilih = diklatAktif.kelasku.filter(i => this.$tools.parseIsBefore(i.server_time, i.tanggal_selesai)).map(i => i.jenis.id);

            // kelas yg sudah selesai dan sudah tuntas, maka jenis kelas yg sama hilang
            // jika kelas yg sudah selesai belum tuntas, maka jenis yg sama muncul kembali
            var kelasTerpilihTuntas = diklatAktif.kelasku
              .filter(i => this.$tools.parseIsAfter(this.$tools.parse0(i.server_time), this.$tools.parse7(i.tanggal_selesai)) && i.progress.status)
              .map(i => i.jenis.id);

            kelasTerpilih = [...kelasTerpilih, ...kelasTerpilihTuntas];

            jenisKelasFiltered = jenisKelasFiltered.filter(i => !kelasTerpilih.includes(i.id));
          }

          return Promise.all(
            jenisKelasFiltered.map(jenis => {
              return this.$store.dispatch("kelas/getPrasyarat", {instansi_id: this.instansi_id, jenis_id: jenis.id}).then(res => {
                jenis.syaratKelases = [...res];

                var syaratPSP = this.config.filter(r => r.key == "syaratKS_PSP");
                this.syaratKS_PSP = syaratPSP && syaratPSP.length > 0 ? true : false;
                var syaratSMKPK = this.config.filter(r => r.key == "syaratKS_SMKPK");
                this.syaratKS_SMKPK = syaratSMKPK && syaratSMKPK.length > 0 ? true : false;

                // pengecekan apakah jenis kelas yang di load memenuhi syarat
                var statusSyarat = [];
                jenis.syaratKelases.forEach(syarat => {
                  statusSyarat.push(syarat.status);
                });
                if (statusSyarat.includes(false)) {
                  return (jenis.isdisable = true);
                } else {
                  return (jenis.isdisable = false);
                }
              });
            })
          )
            .then(() => {
              var checkKelasRunning = jenisKelasFiltered.length > 0 ? true : false;
              var checkKelasAvailable = false;
              //mode hidden jenis yg tidak memenuhi syarat (ex:AKM)
              if (this.current_instansi.mode_id == 1) {
                var tempJenis = jenisKelasFiltered.filter(jenisKelas => jenisKelas.isdisable != true);
                this.jenisKelases = [...tempJenis];
                //jika ada 1 kelas saja yg tersedia maka checkKelasAvailable=true
                checkKelasAvailable = tempJenis.length > 0 ? true : false;
                if (checkKelasRunning == true && checkKelasAvailable == false) {
                  this.cardSyaratGagal = true;
                }
              } else {
                this.jenisKelases = [...jenisKelasFiltered];

                // cek apakah ada kelas yg sedang berjalan
                // jika ada kosongkan jenis kelasnya (khusus: PAUD Inovasi)
                if (this.instansi_id == 6) {
                  var kelasAktif = this.filteredKelasAktif(this.diklatku[0].kelasku);
                  this.jenisKelases = kelasAktif.length > 0 ? [] : this.jenisKelases;
                }
                this.cardSyaratGagal = false;
              }
            })
            .catch(e => e);
        })
        .catch(e => e);
    },

    cekJadwalUlang(diklat, jenis, last) {
      var tempStatus = false;
      // menambahkan pengecekan yang bisa jadwal ulang hanya jika kelasnya bukan kelas publik dan kelasnya punya atribut is_pindah true
      var kelasFiltered = diklat.kelasku.filter(k => k.jenis == jenis && !k.is_publik && k.jenis.is_pindah);

      kelasFiltered.forEach(k => {
        if (this.$tools.parseIsAfter(k.server_time, k.tanggal_selesai)) {
          if (last) {
            tempStatus = true;
          } else {
            tempStatus = false;
          }
        }
      });
      return tempStatus;
    },

    getCourse() {
      return this.$store
        .dispatch("diklat/getDiklatku", {
          instansi_id: this.instansi_id
        })
        .then(res => {

          this.getJenisKelas(res.length > 0 ? res[0] : null);


          res[0].kelasku.forEach(item=>{
            if(item.nama=='LMS Pembelajaran'){
              this.infoUnggahDokumen()
            }
          })



          this.diklatku = res;
          this.loadInformasi();


          // jika ada kelas yang masih on progress cek apakah perangkat mobile
          if (this.filteredKelasAktif(res[0].kelasku).length > 0) {
            if (this.$device.isAndroid && this.current_instansi.is_mobile) {
              this.getTokenSSO();
            }
          }

          // cek jika diklatkunya tidak kosong
        })
        .then(() => {
        })
        .catch(e => e);
    },

    filteredKelasAktif(k) {
      var kelasFiltered = k.filter(kelas => !kelas.progress.status && this.$tools.parseIsBefore(kelas.server_time, kelas.tanggal_selesai));
      // hilangkan kelas yang is_show nilai = 1, progress status = 0, progress percentagenya 100
      kelasFiltered = kelasFiltered.filter(kf => !(kf.jenis.is_show_nilai && kf.progress && kf.progress.data.percentage == 100));
      // cek apakah ada kelas lanjutan yang bisa dikerjakan
      if (kelasFiltered.length > 0) {
        this.inProgressClass = true;
      } else {
        this.inProgressClass = false;
      }
      return kelasFiltered;
    },

    filteredKelasComplete(k) {
      var tempKelasAKtif = [];
      k.forEach(kelas => {
        if (kelas.progress.status) {
          tempKelasAKtif.push(kelas);
        } else if (this.$tools.parseIsAfter(kelas.server_time, kelas.tanggal_selesai)) {
          tempKelasAKtif.push(kelas);
        } else if (kelas.progress && kelas.progress.data.percentage == 100 && kelas.jenis.is_show_nilai == 1) {
          tempKelasAKtif.push(kelas);
        }
        // melakukan pengecekan apakah bimtek AKM sudah ada yg selesai
        if (this.jenisAKM.includes(kelas.jenis.id) && kelas.progress.status) {
          this.is_lulus_bimtek = true;
        }
      });

      // Mengurutkan berdasarkan ID (ID kecil ditampilkan paling atas)
      tempKelasAKtif.sort((a, b) => a.id - b.id);

      return tempKelasAKtif;
    },

    infoJoinTelegram() {
      this.joinTelegram = true;
      return this.$refs.dlgInfoTelegram.open().catch(e => e);
    },

    cekSekolahSasaran(val) {

      const adaSasaranBelumTerdaftar = val.some(item => item.is_sasaran && !item.is_terdaftar_diklat);

      if (adaSasaranBelumTerdaftar) {
        return this.$refs.dlgSekolahSasaran.open(val).catch(e => e);
      }
    },

    infoUnggahDokumen() {
      return this.$refs.dlgInfoKomunitas.open().catch(e => e);
    },

    // model pilih, ulang, lolos (get jadwal selanjutnya)
    // showItem = menampilkan pilihan item kelas atau tidak
    // parameter jenis untuk memfilter kelas mana yg akan di request
    pilihJadwal(model, obj, showCourses, jenis) {
      return this.$refs.dlgKelas
        .open(model, obj, showCourses, jenis)
        .then(() => {
          this.getCourse();
        })
        .catch(e => e);
    },

    formSurvei(obj, showCourses, jenis) {
      return this.$refs.dlgInstansi
        .open(obj, showCourses, jenis)
        .then(() => {
          this.getCourse();
        })
        .catch(e => e);
    },

    formToken(obj, showCourses, jenis) {
      return this.$refs.dlgKelasToken
        .open(obj, showCourses, jenis)
        .then(() => {
          this.getCourse();
        })
        .catch(e => e);
    },

    unggahVideo(obj, showCourses, jenis) {
      return this.$refs.dlgVideoPengimbasan
        .open(obj, showCourses, jenis)
        .then(() => {
          this.getCourse();
        })
        .catch(e => e);
    },

    ubahJadwal(jadwal) {
      return this.$refs.dlgKelas
        .open("ubah", jadwal, true, jadwal.jenis.id)
        .then(() => {
          this.getCourse();
        })
        .catch(e => e);
    },

    //digunakan untuk pengecekan kelas terakhir yang harus diselesaikan oleh pengguna
    cekStatusKelas() {
      var firstClass = this.diklatku[0].kelasku[0];
      // get kelas terakhir yang masih berjalan dan harus diselesaikan
      var lastClass = this.diklatku[this.diklatku.length - 1].kelasku[this.diklatku[this.diklatku.length - 1].kelasku.length - 1];
      this.lastCourse = lastClass;

      if (this.diklatku[0].kelasku.length == 2 && firstClass.progress.status && lastClass.progress.status == false) {
        this.infoJoinTelegram().then(() => {
          this.infoKelas = {
            is_publik: false,
            nama: lastClass.nama,
            tanggal_akhir: lastClass.tanggal_selesai,
            link_learndash: lastClass.link_learndash
          };
          this.$refs.dlgInfoKelas.open(this.infoKelas).catch(e => e);
        });
      } else if (!firstClass.progress.status) {
        this.infoKelas = {
          is_publik: true,
          nama: firstClass.nama,
          link_learndash: firstClass.link_learndash
        };

        this.$refs.dlgInfoKelas.open(this.infoKelas).catch(e => e);
      } else if (this.$tools.checkKelasRunningST(lastClass.server_time, lastClass) && !lastClass.progress.status) {
        this.infoKelas = {
          is_publik: false,
          nama: lastClass.nama,
          tanggal_akhir: lastClass.tanggal_selesai,
          link_learndash: lastClass.link_learndash
        };
        this.$refs.dlgInfoKelas.open(this.infoKelas).catch(e => e);
      } else {
        this.infoKelas = null;
      }
      return;
    },

    toCourse(val) {
      window.open(val.link_learndash, "_blank");
    },

    toSertifikat() {
      this.$refs.dlgSertifikat
        .open(this.is_lulus_bimtek)
        .then(() => {
          this.getCourse();
        })
        .catch(e => e);
    },

    toSyaratPengimbasan(obj) {
      this.$refs.dlgPengimbasan
        .open(obj)
        .then(() => {
          this.loadStatusPengimbasan();
        })
        .catch(e => e);
    }

  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  watch: {
    instansi_id(n) {
      if (n) {
        this.lastMissedClass = null;
        this.diklat = [];
        this.diklats = [];
        this.loadConfig();
        this.getCourse();
      }
    }
  }
};
</script>
<style>
.transparent {
  background-color: transparent !important;
  border-color: transparent !important;
}

.flex {
  display: flex; /*Deklarasi display flex + antek2nya*/
  -moz-display: flex;
  -webkit-display: flex;
  -khtml-display: flex;
  -o-display: flex;
  justify-content: space-between;
}
</style>

<style scoped>
/* Komponen Vue.js Styles */
.my-custom-alert {

/
/
Sesuaikan dengan variabel-variabel yang diubah
.v-alert__icon {
  font-size: $ alert-prominent-icon-font-size !important;
  width: $ alert-prominent-icon-size !important;
  height: $ alert-prominent-icon-size !important;
}

}
